/* eslint-disable @typescript-eslint/explicit-function-return-type */
/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { ErrorType } from '../../modules/Network/orvalHTTPInterface';
import { HTTP } from '../../modules/Network/orvalHTTPInterface';

import type { ApiFrontendInternalLinkingRegionRetrieve200 } from './model/apiFrontendInternalLinkingRegionRetrieve200';

export const apiFrontendInternalLinkingRegionRetrieve = (
  countryCode: string,
  regionSlug: string,
  signal?: AbortSignal
) => {
  return HTTP<ApiFrontendInternalLinkingRegionRetrieve200>({
    url: `/api/v7/frontend/internal-linking/${countryCode}/${regionSlug}/`,
    method: 'GET',
    signal,
  });
};

export const getApiFrontendInternalLinkingRegionRetrieveQueryKey = (
  countryCode?: string,
  regionSlug?: string
) => {
  return [`/api/v7/frontend/internal-linking/${countryCode}/${regionSlug}/`] as const;
};

export const getApiFrontendInternalLinkingRegionRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiFrontendInternalLinkingRegionRetrieve>>,
  TError = ErrorType<unknown>
>(
  countryCode: string,
  regionSlug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiFrontendInternalLinkingRegionRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiFrontendInternalLinkingRegionRetrieveQueryKey(countryCode, regionSlug);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiFrontendInternalLinkingRegionRetrieve>>
  > = ({ signal }) => apiFrontendInternalLinkingRegionRetrieve(countryCode, regionSlug, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(countryCode && regionSlug),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof apiFrontendInternalLinkingRegionRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiFrontendInternalLinkingRegionRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiFrontendInternalLinkingRegionRetrieve>>
>;
export type ApiFrontendInternalLinkingRegionRetrieveQueryError = ErrorType<unknown>;

export function useApiFrontendInternalLinkingRegionRetrieve<
  TData = Awaited<ReturnType<typeof apiFrontendInternalLinkingRegionRetrieve>>,
  TError = ErrorType<unknown>
>(
  countryCode: string,
  regionSlug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiFrontendInternalLinkingRegionRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiFrontendInternalLinkingRegionRetrieveQueryOptions(
    countryCode,
    regionSlug,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}
